import { FC, ReactNode } from "react";
import MediaBlock from "../blocks/MediaBlock";
import Typography from "../Typography";

export type HowItWorks3StepStep = {
  number: number;
  title: ReactNode;
  body: ReactNode;
  videoSrc: string;
  videoAlt: string;
};

type HowItWorks3StepProps = {
  sectionTitle: ReactNode;
  steps: HowItWorks3StepStep[];
};

const HowItWorks3Step: FC<HowItWorks3StepProps> = ({ sectionTitle, steps }) => {
  return (
    <section className="mx-auto text-center my-32 md:my-48 px-3 max-w-[1500px] md:px-12">
      <Typography variant="h2" component="h2" className="max-w-3xl mx-auto">
        {sectionTitle}
      </Typography>
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 mt-16">
        {steps.map((step) => (
          <article key={step.number} className="flex-1 text-start">
            <div className="bg-slate-150 rounded-2xl flex items-center justify-center px-6 pt-6 overflow-hidden">
              <MediaBlock
                data={{
                  type: "video",
                  src: step.videoSrc,
                  alt: step.videoAlt,
                }}
                className="rounded-b-none rounded-t-lg w-full"
              />
            </div>
            <Typography variant="subtitle1" className="mt-6 block">
              <span className="text-violet-500 font-semibold mr-2">
                {String(step.number).padStart(2, "0")}.
              </span>
              {step.title}
            </Typography>
            <Typography variant="body2" className="mt-2 text-slate-500">
              {step.body}
            </Typography>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks3Step;
